import React from "react";
import "./CostComparisonChart.css";

const CostComparisonChart = ({
  myWeeklyCost,
  myMonthlyCost,
  myAnnualCost,
  absWeeklyCost,
  absMonthlyCost,
  absAnnualCost,
}) => {
  const data = [
    {
      label: "Weekly",
      myCost: myWeeklyCost,
      absCost: absWeeklyCost,
    },
    {
      label: "Monthly",
      myCost: myMonthlyCost,
      absCost: absMonthlyCost,
    },
    {
      label: "Annual",
      myCost: myAnnualCost,
      absCost: absAnnualCost,
    },
  ];

  // 找最大值做比例
  const maxValue = Math.max(
    ...data.map((d) => Math.max(d.myCost, d.absCost)),
    1
  );

  return (
    <div className="chart">
      <h2 className="chart__title">Cost Comparison</h2>

      <div className="chart__container">
        {data.map((item) => (
          <div key={item.label} className="chart__group">
            <div className="chart__bars">
              <div
                className="chart__bar chart__bar--my"
                style={{
                  height: `${(item.myCost / maxValue) * 100}%`,
                }}
              >
                <span className="chart__value">
                  {item.myCost.toFixed(0)}
                </span>
              </div>

              <div
                className="chart__bar chart__bar--abs"
                style={{
                  height: `${(item.absCost / maxValue) * 100}%`,
                }}
              >
                <span className="chart__value">
                  {item.absCost.toFixed(0)}
                </span>
              </div>
            </div>

            <p className="chart__label">{item.label}</p>
          </div>
        ))}
      </div>

      <div className="chart__legend">
        <span className="chart__legend-item">
          <span className="chart__legend-color chart__legend-color--my"></span>
          My Cost
        </span>

        <span className="chart__legend-item">
          <span className="chart__legend-color chart__legend-color--abs"></span>
          ABS Smoking
        </span>
      </div>
    </div>
  );
};

export default CostComparisonChart;